export const OPEN_FILTER_MOBILE = (state) => {
  state.openMobileFilter = true;
};

export const CLOSE_FILTER_MOBILE = (state) => {
  state.openMobileFilter = false;
};
